import Base from "./Base"
import Live from "./Live"

const config = {
  ...Live,
  clientKiosk: true,
  clientLinkBaseUri: "https://app.operandio.com",

  auth: Live.auth ? { ...Live.auth } : { ...Base.auth },
}

config.auth.idleTimeoutMs = 1000 * 60 // 60 seconds

export default config
